<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`">
          <fg-input
            :label="`${$t('inventory.toxicity_classification')}: *`"
            ref="name"
            type="text"
            v-model="model.name"
            v-validate="modelValidations.name"
            name="inventory.toxicity_classification"
            :error="getError('inventory.toxicity_classification', true)"
            :placeholder="`${$t('inventory.toxicity_classification')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.color') }}</label>
            <div class="block">
              <el-color-picker
                class="select-primary custom-width-select required-color"
                v-model="model.color"
                :show-alpha="false"
                color-format="hex"
              ></el-color-picker>
            </div>
          </div>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.text_color') }}</label>
            <div class="block">
              <el-color-picker
                class="select-primary custom-width-select mb-3 shadow-sm required-text_color"
                v-model="model.text_color"
                :show-alpha="false"
                color-format="hex"
              ></el-color-picker>
            </div>
          </div>
        </div>
        <div :class="`col-12`">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinColors from 'src/util/mixinColor';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinColors,
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinLoading,
    MixinValidations,
  ],
  data() {
    return {
      disabledField: false,
      businessesInitial: [],
      model: {
        name: null,
        color: null,
        text_color: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        name: { required: true },
      },
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.color)) {
            SweetAlert.warning(i18n.t('common_words.color_not_selected'));

            return false;
          } else if (!isset(this.model.text_color)) {
            SweetAlert.warning(i18n.t('common_words.text_color_not_selected'));

            return false;
          }
          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, name, color, text_color } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        ...this.model,
        id,
        name,
        color,
        text_color,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
